var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`gts-info-badge gts-info-badge__${_vm.badgeClassName} ${_vm.modifier ? _vm.modifier : ''}`},[_vm._v(_vm._s(_vm.badgeText))])
}
var staticRenderFns = []

export { render, staticRenderFns }